import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, itemOrdersActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, itemOrdersActions);

export default slice.reducer;
